import { atom } from "recoil";

export const DataFromCsvAtom = atom<any[] | null>({
  key: "DataFromCsv",
  default: null,
});
